<template src="./forgotPassword.html"></template>

<script>
import mixins from "@/Mixins.js";
import router from "@/router/router";

export default {
  mixins: [mixins],
  data() {
    return {
      password1: "",
      password2: "",
      invalidFields: {
        password1: false,
        password2: false,
      },
      textMessage: {
        password1:
          "Senha inválida, digite uma nova senha seguindo a orientação!",
        password2: "A senha e a confirmação de senha devem ser iguais.",
      },
      passwordType1: "password",
      passwordType2: "password",
    };
  },
  methods: {
    verifyPassword() {
      this.invalidFields.password2 = this.password1 !== this.password2;
    },

    verifyPasswordStrenght() {
      this.invalidFields.password1 = this.testPasswordStrength(this.password1);
    },

    password1Visibility() {
      this.passwordType1 = this.passwordType1 === "password" ? "text" : "password";
    },

    password2Visibility() {
      this.passwordType2 = this.passwordType2 === "password" ? "text" : "password";
    },

    goHome() {
      router.push("/");
    },

    submit() {
      this.verifyPasswordStrenght();
      this.verifyPassword();
      
      if (this.invalidFields.password1 || this.invalidFields.password2) {
        return;
      }
      const token = this.$route.params.token;
      this.axios
        .put(
          `${this.$store.state.filooServer}users/forgot-password/${token}`, 
          {
            password: this.password1,
          }
        )
        .then(response =>{
          if (response.status === 200) {
            this.$bvModal.show("modal-change-password-success");
          }
        })
        .catch(error => {
          if(error.response.status === 412) {
            this.swallError(error.message).then(() => {
              this.goHome();
            }); 
          }else{
            this.swallError().then(() => {
              this.goHome();
            });
          }
        });
    },
    testPasswordStrength(password) {
      const regex =
        /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (password == "") return;
      return !regex.test(password)
    },

    swallError(message) {
      return this.$swal({
        title: "Atenção!",
        text: message == null ? "Ocorreu um erro, tente novamente ou contate um administrador." : message,
        icon: "error",
      });
    },
    swallSuccess() {
      return this.$swal({
        title: "Sucesso!",
        text: "A sua senha foi salva, clique no botão abaixo para realizar o seu login.",
        icon: "success",
      });
    },
  },
};
</script>
<style lang="scss" src="./forgotPassword.scss" />
